/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { Box, Flex, Label, Text } from '@bottlebooks/gatsby-theme-base';
import React from 'react';
import { jsx } from 'theme-ui';
import BrandLogo from '../Brand/BrandLogo';
import Mark from '../Mark';
import ListRowSmall from './ListRowSmall';
/**
 *
 * @param {object} props
 * @param {{ name?: string?; countryName?: string?; region?: string?; city?: string?; stand?:{ name?: string | null }? }} props.exhibitor;
 * @param {string} [props.searchTerm]
 * @param {string} [props.to]
 * @param {React.MouseEventHandler} [props.onClick]
 * @returns
 */
export default function ExhibitorListRowSmall({
  exhibitor,
  searchTerm,
  to,
  ...rest
}) {
  const subtitle = [exhibitor.countryName, exhibitor.region, exhibitor.city]
    .filter(Boolean)
    .join(', ');
  return (
    <ListRowSmall to={to} {...rest}>
      <Flex gap={2} align="center" sx={{ width: '100%' }}>
        <BrandLogo brand={exhibitor} size="smaller" />
        <Box>
          {searchTerm ? (
            <>
              <Label variant="small" sx={{ color: 'lighterText' }}>
                <Mark
                  text={exhibitor.stand?.name}
                  term={searchTerm}
                  render={(match) => (
                    <span sx={{ fontWeight: 'bold', color: 'text' }}>
                      {match}
                    </span>
                  )}
                />
              </Label>
              <Mark
                text={exhibitor.name}
                term={searchTerm}
                render={(match) => (
                  <span sx={{ fontWeight: 'bold', color: 'text' }}>
                    {match}
                  </span>
                )}
                Wrapper={LargeText}
                append={(term) => (
                  <Text
                    variant="small"
                    sx={{ fontWeight: 'regular', color: 'lighterText' }}
                  >
                    <Mark
                      text={subtitle}
                      term={term}
                      render={(match) => (
                        <span sx={{ fontWeight: 'bold', color: 'text' }}>
                          {match}
                        </span>
                      )}
                    />
                  </Text>
                )}
              />
            </>
          ) : (
            <>
              <Label variant="small" sx={{ color: 'lighterText' }}>
                {exhibitor.stand?.name}
              </Label>
              <Text variant="large">{exhibitor.name}</Text>
              <Text variant="small" sx={{ color: 'lighterText' }}>
                {subtitle}
              </Text>
            </>
          )}
        </Box>
      </Flex>
    </ListRowSmall>
  );
}

function LargeText(props) {
  return (
    <Text
      variant="large"
      sx={{ fontWeight: 'regular', color: 'lighterText' }}
      {...props}
    />
  );
}
